const urlMatcher = /(https?:\/\/)?[\w\-~]+((\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w-]*)?(\?[^\s]*)?)+/gim; // eslint-disable-line max-len

export default function matchUrls(string) {
  return string.match(urlMatcher);
}
